
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { CkdMaterialComponent } from '../ckd-material/ckd-material.component';
import { UserInsertComponent } from '../../system/user/user-insert/user-insert.component';
import { CkdMaterialListComponent } from '../ckd-material-list/ckd-material-list.component';
import { CkdMaterial2Component } from '../ckd-material2/ckd-material2.component';
import { SaleFactorDetaileComponent } from '../../sale/sale-factor-detaile/sale-factor-detaile.component'
import { CkdDefaultContractComponent } from '../ckd-default-contract/ckd-default-contract.component';
import Num2persian from 'num2persian';


@Component({
  selector: 'app-ckd-detaile',
  templateUrl: './ckd-detaile.component.html',
  styleUrls: ['./ckd-detaile.component.scss']
})
export class CkdDetaileComponent implements OnInit, OnDestroy {
  public server: any = this.serverService.get_server();
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));;
  public loading = false;
  public subscription: Subscription;
  public type_invoice: number;
  public type_task: number | undefined;
  public form1_group: FormGroup;
  public user_id: number | any;
  public id: number | undefined;
  public i: number | undefined;
  public code: number | undefined;
  public title: string | undefined;
  public search_array: any = [];
  public readonly: boolean = false;
  public list_cate2: any = [];
  public sum_all: number = 0;
  public sum_final: number = 0;
  public sum_final_letter: string | undefined;
  public count_all: number = 0;
  public discount_all: number = 0;
  public seleton_id: number = 0;
  public status_skeleton: boolean = false;
  public token: number = 0;
  public tax: number = 0;
  public sum_with_discount: number = 0;

  constructor(
    public serverService: ServerService
    , public router: Router
    , public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any
    , public dialog: MatDialog
    , public matDialogRef: MatDialogRef<CkdDetaileComponent>) {

    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.readonly = dialog_data.readonly;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.get_status();
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.check_access(3, 1);
      }
    }
  }//end consructor

  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  get_sum_all() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10607, ckd_id: this.id, seleton_id: this.form1_group.value.seleton_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.count_all = res['result'][0].count_all;
          this.sum_all = res['result'][0].sum_all;
          this.discount_all = res['result'][0].discount_all;
          this.sum_with_discount = this.sum_all - this.discount_all;
          this.tax = Math.round(this.sum_with_discount * 9 / 100);
          this.sum_final = this.sum_with_discount + this.tax;
          if (this.sum_final) this.sum_final_letter = Num2persian(this.sum_final);
        }//end if
        else {
          var pe_message = "خطا در محاسبه جمع کل";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  select_invoice() {
    if (!this.form1_group.value.seleton_id || this.form1_group.value.seleton_id == null) {
      var pe_message = "باید در ابتدا یک پیش فاکتور انتخاب کرده باشید.";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    const dialogRef = this.dialog.open(SaleFactorDetaileComponent, {
      width: '80rem',
      height: 'auto',
      disableClose: true,
      data: { id: this.form1_group.value.seleton_id, service_id: 32, product: this.type_invoice }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.get_cate2();
          this.get_sum_all();
        }
      }
    )
  }

  add_user() {
    const dialogRef = this.dialog.open(UserInsertComponent, {
      width: '45rem',
      height: 'auto',
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          /*
          this.requester_title = res.user_title;
          this.requester_id = res.user_id
          this.user_sms = res.user_id
          */
        }
      }
    )
  }

  get_cate2() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10606, id: this.id, seleton_id: this.form1_group.value.seleton_id }).subscribe(
      (res: any) => {
        this.list_cate2 = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_cate2.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  open_contract() {
    this.dialog.open(CkdDefaultContractComponent, {
      width: '100rem',
      height: '100vh',
      data: { id: this.id, code: this.code, type_task: 2, ref: 'ckd' }
    })
  }

  select_material(i: number, id: number, cate: number, title: string) {
    if (!this.form1_group.value.tip && !this.form1_group.value.seleton_id) {
      var pe_message = "برای انتخاب متریال در ابتدا باید تیب و یا انتخاب فاکتور مشخص شود";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return false;
    }

    var dialog: any = CkdMaterial2Component;
    if (this.form1_group.value.tip > 0) {
      dialog = CkdMaterialComponent;
    }

    const dialogRef = this.dialog.open(dialog, {
      width: '80rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, cate: cate, title: title, cdk_id: this.id, seleton_id: this.form1_group.value.seleton_id, tip: this.form1_group.value.tip }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.list_cate2[i].count = res.count;
          this.list_cate2[i].sum = res.sum;
        }
        this.get_sum_all();
      }
    )
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'customer_title': new FormControl(null),
      'customer': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'seleton_title': new FormControl(null),
      'seleton_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'tip_title': new FormControl(null),
      'tip': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['status_id'].setValidators([Validators.required])
    }
  }

  check_access(type_task: any, excel: number): any {
    if (this.readonly == true && (type_task == 2 || type_task == 1)) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.title = res['result'][0].title;
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) {
              this.form1_group.patchValue({
                title: this.dialog_data.search_array.title,
                status_id: this.dialog_data.search_array.status_id,
                status_title: this.dialog_data.search_array.status_title,
                customer: this.dialog_data.search_array.customer,
                customer_title: this.dialog_data.search_array.customer_title,
                seleton_id: this.dialog_data.search_array.seleton_id,
                seleton_title: this.dialog_data.search_array.seleton_title,
              })
            }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      seleton_id: this.form1_group.value.seleton_id,
      seleton_title: this.form1_group.value.seleton_title,
      customer: this.form1_group.value.customer,
      customer_title: this.form1_group.value.customer_title,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10560, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].site_ckd_title,
            'sort': res['result'][0].site_ckd_sort,
            'status_id': res['result'][0].site_ckd_status,
            'status_title': res['result'][0].ckd_status_title,
            'customer_title': res['result'][0].customer_title,
            'customer': res['result'][0].customer,
            'seleton_title': res['result'][0].pre_factor_lsf_order_code_factor,
            'seleton_id': res['result'][0].pre_factor_lsf_order_id,
            'tip_title': res['result'][0].tip_tip_site_title,
            'tip': res['result'][0].tip_tip_site_id,
          }
          );
          this.type_invoice = res['result'][0].pre_factor_lsf_order_product;
          this.token = res['result'][0].site_ckd_token;
          this.status_skeleton = res['result'][0].site_ckd_status_skeleton;
          this.get_cate2();
          this.get_sum_all();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10556, "user_id": this.user_id, 'status_id': this.form1_group.value.status_id
      , 'title': this.form1_group.value.title
      , 'sort': this.form1_group.value.sort
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            {
              result: res['result'][0], sum_all: this.sum_all, sum_final: this.sum_final, discount_all: this.discount_all
              , sum_with_discount: this.sum_with_discount, tax: this.tax
            }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10557, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'customer': this.form1_group.value.customer
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'id': this.id
      , 'seleton_id': this.form1_group.value.seleton_id
      , 'tip': this.form1_group.value.tip
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            {
              result: res['result'][0], i: this.i, sum_all: this.sum_all, count_all: this.count_all, sum_final: this.sum_final, discount_all: this.discount_all
              , sum_with_discount: this.sum_with_discount, tax: this.tax
            }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          this.serverService.send_ckd_status();
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1064 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  open_invoice() {
    if (!this.form1_group.value.tip && !this.form1_group.value.seleton_id) {
      var pe_message = "برای مشاهده فاکتور باید فاکتور و یا تیب انتخاب شده باشد";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    const dialogRef = this.dialog.open(CkdMaterialListComponent, {
      width: '100rem',
      height: '100vh',
      data: { ckd_id: this.id, seleton_id: this.form1_group.value.seleton_id }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        //this.get_data();
        //this.get_sum_all();
      }
    )
  }


  load_services(i: number, id: number) {
    if (this.readonly == true) {
      return false;
    }
    var code_id;
    if (id == 225) {
      for (var i = 0; i < this.list_cate2.length; i++) {
        if (this.list_cate2[i].count > 0) {
          var pe_message = "برای تغییرات باید وضعیت کالاهای انتخاب شده را مشخص نمائید";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          return false;
        }
      }
    }
    if (id == 32) {
      code_id = 10571;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, code_id: code_id, obj: { customer: this.form1_group.value.customer } }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 24) {
            this.form1_group.patchValue({
              'customer': res.id,
              'customer_title': res.title,
              'seleton_title': null,
              'seleton_id': null
            })
          }
          if (id == 223) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title,
            })
          }
          if (id == 32) {
            this.form1_group.patchValue({
              'seleton_title': res.title,
              'seleton_id': res.id
            })
            if (this.type_task != 3) {
              this.get_type_invoice(res.id);
              this.update_ckd();
              this.get_cate2();
              this.get_sum_all();
            }
          }
          if (id == 225) {
            this.form1_group.patchValue({
              'tip': res.id,
              'tip_title': res.title,
            })
            if (this.type_task != 3) {
              this.update_ckd();
              this.get_cate2();
              this.get_sum_all();
            }
          }
        }
      }
    )
  }

  get_type_invoice(id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10573, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.type_invoice = res['result'][0].pre_factor_lsf_order_product;
          }
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //**************************************************************************************************************** */
  update_mwf() {
    var obj = {
      address: 10579, seleton_id: this.seleton_id, ckd_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_mwf();;//res['result'][0].pre_factor_lsf_order_design_all  طراحی سازه
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }





  //**************************************************************************************************************** */
  insert_mwf() {
    var obj = {
      address: 10574, seleton_id: this.seleton_id, ckd_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_all();//res['result'][0].pre_factor_lsf_order_design_all  طراحی سازه
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_design_all() {
    var obj = {
      address: 10575, seleton_id: this.seleton_id, ckd_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_price_lsf(); //res['result'][0].pre_factor_lsf_order_price_lsf هزینه پیچ به تومان
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_design_price_lsf() {
    var obj = {
      address: 10576, seleton_id: this.seleton_id, ckd_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_arch();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_design_arch() {
    var obj = {
      address: 10577, seleton_id: this.seleton_id, ckd_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.get_cate2();
          this.update_ckd();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  update_ckd() {
    var obj = {
      address: 10578
      , id: this.id
      , customer: this.form1_group.value.customer
      , seleton_id: this.form1_group.value.seleton_id
      , tip: this.form1_group.value.tip
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.status_skeleton = true;
          this.get_sum_all();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  reset_input(id: number) {
    if (this.readonly == true) {
      return false;
    }
    if (id == 225) {
      for (var i = 0; i < this.list_cate2.length; i++) {
        if (this.list_cate2[i].count > 0) {
          var pe_message = "برای تغییرات باید وضعیت کالاهای انتخاب شده را مشخص نمائید";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          return false;
        }
      }
    }

    if (id == 24) {
      this.form1_group.patchValue({
        'customer': null,
        'customer_title': null
      })
    }
    if (id == 223) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 32) {
      this.form1_group.patchValue({
        'seleton_title': null,
        'seleton_id': null
      })
      this.get_cate2();
    }
    if (id == 225) {
      this.form1_group.patchValue({
        'tip': null,
        'tip_title': null,
      })
    }
  }


  close() {
    this.matDialogRef.close(
      {
        sum_all: this.sum_all, count_all: this.count_all, sum_final: this.sum_final,
        discount_all: this.discount_all, sum_with_discount: this.sum_with_discount, tax: this.tax
        , export_excel: 1
      }
    )
  }

  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

